<template>
    <div>
        <div>
            <img src="../../assets/mk体育(中国)官方网站 - mk sports/product/3.png" style="width: 100%;height: auto" alt="">
        </div>
        <div class="index-div-content product-info-div">
            <el-row  type="flex" class="product-info-div-flex">
                <el-col :xs="24" :sm="14">
                    <router-link to="/product/sensor/stainless-steel-sensor"> <h3 class="font-24 product-header">不锈钢烟雾传感器</h3></router-link>
                    <p class="product-content">
                        mk体育智能为解决煤矿、水泥、电力、钢铁、港口行业的现场烟雾、火情监测专门研发的传感器监测和实时预警系统，产品具有耐高低温、耐腐蚀、耐氧化、抗干扰强、高效精准等优点，广泛应用于恶劣的现场环境。</p>
                    <router-link to="/product/sensor/stainless-steel-sensor">
                    <el-button type="primary" class="button " style="width: 70px">
                        详情
                    </el-button></router-link>
                </el-col>
                <el-col :xs="24" :sm="10">
                    <div class="product-image-zoom">
                        <div class='magnify'>
                            <div class='large'></div>
                            <img src="../../assets/mk体育(中国)官方网站 - mk sports/product/5.png" class='small' alt="">
                        </div>
                    </div>
                </el-col>
            </el-row>

        </div>
        <div class="index-div-content product-info-div">
            <el-row  type="flex" class="product-info-div-flex">
                <el-col :xs="24" :sm="14">
                    <router-link to="/product/sensor/wzsensor"><h3 class="font-24 product-header">温度/振动传感器系统</h3></router-link>
                    <p class="product-content">
                        专门为电机、减速机、大型辊筒配备振动传感器，通过慈吸或胶粘的方式安装在轴承座上，对滚筒、减速机、电机的轴承振动进行实时监测，监测数据传至管理后台。该振动传感器可同时采集震动及温度值。</p>
                    <router-link to="/product/sensor/wzsensor">
                    <el-button type="primary" class="button " style="width: 70px">
                        详情
                    </el-button></router-link>
                </el-col>
                <el-col :xs="24" :sm="10">
                    <div class="magnify">
                        <img src="../../assets/mk体育(中国)官方网站 - mk sports/product/4.png" alt="">
                    </div>
                   </el-col>
            </el-row>

        </div>
    </div>
</template>

<script>

    export default {
        name: "robot"
    }


</script>

<style scoped lang="scss">


</style>